import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialSpeakerAnnounce: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 5.33H32v18.29h-1.53Zm-1.52 18.29h1.52v1.52h-1.52Zm0-19.81h1.52v1.52h-1.52Zm-1.52 21.33h1.52v1.52h-1.52Zm0-22.86h1.52v1.53h-1.52ZM25.9 20.57h1.53v1.52H25.9Zm0-13.71h1.53v1.52H25.9Zm-3.05 19.8h4.58v1.53h-4.58Zm1.53-7.61h1.52v1.52h-1.52Zm0-10.67h1.52V9.9h-1.52ZM22.85.76h4.58v1.52h-4.58Zm0 9.14h1.53v9.15h-1.53Zm-3.04 15.24h3.04v1.52h-3.04Zm0-22.86h3.04v1.53h-3.04Zm-3.05 21.34h3.05v1.52h-3.05Zm0-19.81h3.05v1.52h-3.05Zm-4.57 18.28h4.57v1.53h-4.57Zm0-16.76h4.57v1.53h-4.57ZM9.14 20.57V8.38h3.05V6.86H4.57v1.52H1.52V9.9H0v9.15h1.52v1.52h3.05v9.14h1.52v-7.62h3.05v7.62h1.52v-7.62h1.53v-1.52Zm-4.57-9.14H3.05v3.04H1.52v-3.04h1.53V9.9h1.52Zm1.52 18.28h3.05v1.53H6.09Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialSpeakerAnnounce
